import axios from "axios";

const tokenApi = axios.create({
  baseURL: `${process.env.REACT_APP_API_2024_URL}/internal/api/tokens`,
  headers: {
    "x-api-token": process.env.REACT_APP_API_2024_TOKEN,
  },
});

export default tokenApi;
